export default __webpack_public_path__ + "static/Alhamd_corporation-59cac25f98d3d645e239e5b0df25c75d.jpg";